import { useTranslation } from "react-i18next";
import { ShieldOff, LogOut } from "lucide-react";
import { useAuth, AUTH_ROUTES } from "@ticketon/authentication-core";

/**
 * Page shown when user has no permissions at all.
 * This is a "nuclear" access denied - the user can't access anything.
 */
export function NoAccessPage() {
  const { t } = useTranslation();
  const { clearAuth } = useAuth();

  const handleLogout = () => {
    clearAuth();
    window.location.href = AUTH_ROUTES.LOGIN;
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <div className="rounded-full bg-red-50 p-4 w-20 h-20 mx-auto mb-6 flex items-center justify-center">
          <ShieldOff className="h-10 w-10 text-red-500" />
        </div>

        <h1 className="text-xl font-semibold text-gray-900 mb-2">
          {t("no_access.title")}
        </h1>

        <p className="text-red-600 font-medium mb-2">
          {t("no_access.subtitle")}
        </p>

        <p className="text-gray-600 mb-6">
          {t("no_access.message")}
        </p>

        <button
          onClick={handleLogout}
          className="inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors"
        >
          <LogOut className="h-4 w-4" />
          {t("logout")}
        </button>
      </div>
    </div>
  );
}

export default NoAccessPage;
